import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';
import { Announcement } from '../../types';

export const Announcements: React.FC = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    api.getAnnouncements().then(data => {
      setAnnouncements(data);
    });
  }, []);

  useEffect(() => {
    if (announcements.length < 2) return;
    const timer = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % announcements.length);
    }, 7000);
    return () => clearInterval(timer);
  }, [announcements]);

  if (announcements.length === 0) {
    return null;
  }

  const currentAd = announcements[currentIndex];

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex flex-col items-center text-center space-y-4">
      
      {/* Mensaje del anuncio */}
      <p key={currentIndex} className="text-gray-700 text-lg animate-fade-in">
        {currentAd?.message}
      </p>

      {/* Imagen del anuncio */}
      {currentAd?.imageUrl && (
        <div className="w-full max-w-lg mt-4 rounded-lg overflow-hidden">
          <img
            src={currentAd.imageUrl}
            alt="Anuncio"
            className="w-full h-auto object-contain mx-auto"
          />
        </div>
      )}
    </div>
  );
};
